import React, { useState, useEffect } from "react";
import "./AdForm.css";
import { X } from "lucide-react";

export default function AdForm({ isOpen, onClose, pageTitle }) {
    const [formData, setFormData] = useState({
        fullName: "",
        email: "",
        company: "",
        role: "",
        companySize: "",
        toolsInterested: pageTitle || "",
        intendedUse: "",
        additionalInfo: ""
    });

    useEffect(() => {
        if (isOpen && window.fbq) {
            window.fbq('trackCustom', 'RequestDemoOpened', {
                page_title: pageTitle
            });
        }
    }, [isOpen, pageTitle]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        
        if (window.fbq) {
            window.fbq('track', 'Lead', {
                content_name: pageTitle,
                content_category: 'Demo Request'
            });
        }

        console.log("Form Data Submitted:", formData);
        alert("Demo request submitted successfully! We'll be in touch soon.");
        onClose();
    };

    return (
        <div className="ad-modal-overlay" onClick={onClose}>
            <div className="ad-modal-content" onClick={e => e.stopPropagation()}>
                <button className="ad-modal-close" onClick={onClose}>
                    <X size={24} />
                </button>

                <div className="ad-modal-header">
                    <h2>Request Demo Access</h2>
                    <p>Demos are provided with limited credentials after review. Enterprise and white-label demos require NDA.</p>
                </div>

                <form className="ad-modal-form" onSubmit={handleSubmit}>
                    <div className="form-grid">
                        <div className="form-group">
                            <label htmlFor="fullName">Full Name *</label>
                            <input
                                type="text"
                                id="fullName"
                                name="fullName"
                                required
                                value={formData.fullName}
                                onChange={handleChange}
                                placeholder="Your full name"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="email">Email *</label>
                            <input
                                type="email"
                                id="email"
                                name="email"
                                required
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="name@company.com"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="company">Company *</label>
                            <input
                                type="text"
                                id="company"
                                name="company"
                                required
                                value={formData.company}
                                onChange={handleChange}
                                placeholder="Company name"
                            />
                        </div>
                        <div className="form-group">
                            <label htmlFor="role">Role *</label>
                            <input
                                type="text"
                                id="role"
                                name="role"
                                required
                                value={formData.role}
                                onChange={handleChange}
                                placeholder="Designation"
                            />
                        </div>
                    </div>

                    <div className="form-group">
                        <label htmlFor="companySize">Company Size *</label>
                        <select id="companySize" name="companySize" required value={formData.companySize} onChange={handleChange}>
                            <option value="">Select company size</option>
                            <option value="1-10">1-10 employees</option>
                            <option value="11-50">11-50 employees</option>
                            <option value="51-200">51-200 employees</option>
                            <option value="201-500">201-500 employees</option>
                            <option value="501+">501+ employees</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="toolsInterested">Tool(s) Interested In *</label>
                        <input
                            type="text"
                            id="toolsInterested"
                            name="toolsInterested"
                            required
                            value={formData.toolsInterested}
                            onChange={handleChange}
                            placeholder="e.g., Proposal Automation Engine, AI Ad Creative Generator"
                        />
                    </div>

                    <div className="form-group">
                        <label htmlFor="intendedUse">Intended Use *</label>
                        <select id="intendedUse" name="intendedUse" required value={formData.intendedUse} onChange={handleChange}>
                            <option value="">Select intended use</option>
                            <option value="internal">Internal Use</option>
                            <option value="resale">Resale</option>
                            <option value="white-label">White-Label</option>
                            <option value="partnership">Strategic Partnership</option>
                        </select>
                    </div>

                    <div className="form-group">
                        <label htmlFor="additionalInfo">Additional Information</label>
                        <textarea
                            id="additionalInfo"
                            name="additionalInfo"
                            value={formData.additionalInfo}
                            onChange={handleChange}
                            placeholder="Tell us more about your use case and requirements..."
                            rows="4"
                        ></textarea>
                    </div>

                    <button type="submit" className="ad-form-submit">
                        Request Access
                    </button>
                </form>
            </div>
        </div>
    );
}
